import React from 'react'
import { Link } from 'react-router-dom'

import project_girl from '../../assets/project_girl.png'
import project1 from '../../assets/project1.png'
import project2 from '../../assets/project2.png'
import project3 from '../../assets/project3.png'
import project_bg from '../../assets/ww.png'

const ProjectDetail = () => {
	const projects = [
		{
			id: 1,
			image: project1,
			category: 'Movie',
			title: 'Power of Africa',
			description:
				'A movie about the power struggles in Africa, just after the colonial era...',
			percentage: 100,
			status: 'Project Funded',
		},
		{
			id: 2,
			image: project2,
			category: 'Movie',
			title: 'Traditional Sisters',
			description:
				'Contrary to popular belief, Lorem Ipsum is not simply random text...',
			percentage: 100,
			status: 'Project Funded',
		},
		{
			id: 3,
			image: project3,
			category: 'Short Stories',
			title: 'Shadow Queen',
			description:
				'Contrary to popular belief, Lorem Ipsum is not simply random text...',
			percentage: 50,
			status: 'Project in Funding',
		},
		{
			id: 4,
			image: project1,
			category: 'Movie',
			title: 'Power of Africa',
			description:
				'A movie about the power struggles in Africa, just after the colonial era...',
			percentage: 100,
			status: 'Project Funded',
		},
	]

	return (
		<>
			<section
				className='project_details_white'
				style={{ background: `url(${project_bg})` }}
			>
				<div className='container'>
					<h1 className='text-center page_header'> Power of Africa </h1>

					<div className='row'>
						<div className='col-md-6'>
							<img src={project_girl} alt='' className='img-fluid' />
							<div className='mt-3'>
								<p>
									<strong>By:</strong>
									<span>
										<img
											src={project1}
											alt=''
											className='author_img mr-2 ml-2'
										/>{' '}
										Anita Baker
									</span>
								</p>
							</div>
						</div>

						<div className='col-md-6'>
							<h5 className='desc'>
								<strong>Description</strong>
							</h5>
							<p>
								There are many variations of passages of Lorem Ipsum available,
								but the majority have suffered alteration in some form, by
								injected humour, or randomised words which don't look even
								slightly believable. If you are going to use a passage of Lorem
								Ipsum, you need to be sure there isn't anything embarrassing
								hidden in the middle of text.
							</p>

							<h5 className='mt-5'>
								<strong>Story</strong>
							</h5>
							<p>
								There are many variations of passages of Lorem Ipsum available,
								but the majority have suffered alteration in some form, by
								injected humour, or randomised words which don't look even
								slightly believable. If you are going to use a passage of Lorem
								Ipsum, you need to be sure there isn't anything embarrassing
								hidden in the middle of text. All the Lorem Ipsum generators on
								the Internet tend to repeat predefined chunks as necessary,
								making this the first true generator on the Internet. It uses a
								dictionary of over 200 Latin words, combined with a handful of
								model sentence structures, to generate Lorem Ipsum which looks
								reasonable. The generated Lorem Ipsum is therefore always free
								from repetition, injected humour, or non-characteristic words
								etc.
							</p>
						</div>
					</div>
				</div>
			</section>

			<section className='project_details_grey'>
				<div className='container'>
					<h4 className='text-center'>
						<strong>Other Projects</strong>
					</h4>

					<div className='homepage_projects project_details_box'>
						<div className='row'>
							{projects.map((project) => (
								<div
									className='col-lg-3 col-md-6 p-4 ml-auto mr-auto'
									key={project.id}
								>
									<div className='homepage_projects_box'>
										<Link to='/projects/1'>
											<img src={project.image} alt='' />
										</Link>
										<div className='homepage_projects_card'>
											<p className='project_category project_category_abs'>
												{project.category}
											</p>
											<h5> {project.title} </h5>
											<p className='project_desc'>{project.description}</p>
											{/* <progress id='file' value={project.percentage} max='100'>
												{project.percentage}
											</progress> */}
											<p className='text-left project_desc'>{project.status}</p>

											<Link
												to='/projects/1'
												className='project_category ml-auto btn'
											>
												View
											</Link>
										</div>
									</div>
								</div>
							))}
						</div>
					</div>
					<div className='text-center mt-5'>
						<Link to='/projects' className='btn homepage_btn'>
							View More
						</Link>
					</div>
				</div>
			</section>
		</>
	)
}

export default ProjectDetail
